import POLICIES from '../security/policies';

export default {
  path: '/user-create-password',
  component: () => import('@/vue-app/views/UserCreatePassword.vue'),
  meta: {
    access_policy: POLICIES.UNAUTHENTICATED,
  },
};
